import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { useHelpPopup } from 'shared/hooks/ui';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { useGetStorageOrFetchIcon } from 'shared/api/hooks';
import { ConverterIconsFromStringToSVG } from 'shared/components/icon/icon.user_icons_panel/converter_icon_from_string_to_svg';
import { ResultConvertingIcon } from 'shared/components/icon/icon.user_icons_panel/result-converting-icon';
import { useMounted } from 'shared/hooks/utils';
import * as React from 'react';
import { useBuyDesignPackage, useDesignPackage } from 'shared/hooks/helpers';
export const UserIcons = memo(function UserIcons(props) {
    const { onChangeIcon, showTitleIcon, showButtonDelete } = props;
    const [HelpPopup, open] = useHelpPopup();
    const [indexIcon, setIndexIcon] = useState();
    const BuyDesignPackage = useBuyDesignPackage(close);
    const allow_design_package = useDesignPackage();
    const is_demo = useAppSelector((state) => state.account.is_demo);
    const idsIconUser = useAppSelector((state) => state.user_icons.idsIconUser);
    const [responseIcon, run, loading, error, errorRun] = useGetStorageOrFetchIcon('get_icons_user');
    const isMounted = useMounted();
    useEffect(() => {
        if (isMounted.current) {
            run(idsIconUser);
        }
    }, [idsIconUser.length]);
    const openTouchTooltip = useCallback((id, event) => {
        open(event);
        setIndexIcon(id);
    }, []);
    const touchTooltip = responseIcon.find((Icon) => Icon.id === indexIcon);
    return (_jsx(_Fragment, { children: allow_design_package && !is_demo ? (idsIconUser?.length !== 0 ? (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'left',
                    }, children: responseIcon.map((el) => {
                        return (loading && error != null) ||
                            errorRun !== null ? (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 32 })) : el.errorIcon ? (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 32 })) : (_jsx(ResultConvertingIcon, { getDataByIcon: el, openTouchTooltip: openTouchTooltip, showTitleIcon: showTitleIcon, showButtonDelete: showButtonDelete, onChangeIcon: onChangeIcon }, el.id));
                    }) }), !onChangeIcon && error === null && (_jsx(HelpPopup, { children: touchTooltip?.icon != null && (_jsx(Box, { display: 'flex', flexDirection: 'column', children: _jsx(ConverterIconsFromStringToSVG, { iconToString: touchTooltip.icon, maintainColor: touchTooltip.maintainColor, fontSize: "10em" }) })) }))] })) : (_jsx(Box, { children: _jsx(Typography, { children: "\u041D\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0445 \u0438\u043A\u043E\u043D\u043E\u043A" }) }))) : (BuyDesignPackage) }));
});
